var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from "@wordpress/element";
import { WPQTInput } from "../../../../components/common/Input/Input";
import { CustomFieldTitle } from "../../../../components/CustomField/CustomFields/components/CustomField/CustomField";
import { Loading } from "../../../../components/Loading/Loading";
import { CustomFieldType } from "../../../../types/custom-field";
import { debounce } from "../../../../utils/debounce";
function CustomField({ data, saveCustomFieldValueChange, valueChangeEnabled = true, }) {
    const handleChange = (value) => __awaiter(this, void 0, void 0, function* () {
        yield saveCustomFieldValueChange(data.id, value);
    });
    switch (data.type) {
        case CustomFieldType.Text: {
            return (_jsx(TextCustomField, { data: data, onHandleChange: handleChange, valueChangeEnabled: valueChangeEnabled }));
        }
        case CustomFieldType.Checkbox: {
            return (_jsx(CheckboxCustomField, { data: data, onHandleChange: handleChange, valueChangeEnabled: valueChangeEnabled }));
        }
    }
}
function TextCustomField({ data, onHandleChange, valueChangeEnabled, }) {
    const [value, setValue] = useState("");
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        setValue(data.value || "");
    }, [data.value]);
    const debouncedHandleChange = useCallback(debounce((newValue) => __awaiter(this, void 0, void 0, function* () {
        setLoading(true);
        yield onHandleChange(newValue);
        setLoading(false);
    }), 600), [onHandleChange]);
    const onChange = (newValue) => {
        setValue(newValue);
        debouncedHandleChange(newValue);
    };
    return (_jsxs("div", { className: "wpqt-text-center", children: [_jsx(CustomFieldTitle, { name: data.name, description: data.description }), _jsx(WPQTInput, { value: value, onChange: onChange, disabled: !valueChangeEnabled, loading: loading })] }));
}
function CheckboxCustomField({ data, onHandleChange, valueChangeEnabled, }) {
    const [isChecked, setIsChecked] = useState(data.value === "true");
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        setIsChecked(data.value === "true");
    }, [data.value]);
    const onChange = (e) => __awaiter(this, void 0, void 0, function* () {
        setIsChecked(e.target.checked);
        setLoading(true);
        yield onHandleChange(e.target.checked ? "true" : "false");
        setLoading(false);
    });
    return (_jsxs("div", { className: "wpqt-text-center", children: [_jsx(CustomFieldTitle, { name: data.name, description: data.description }), loading ? (_jsx(Loading, { ovalSize: "24" })) : (_jsx("input", { type: "checkbox", checked: isChecked, onChange: onChange, disabled: !valueChangeEnabled }))] }));
}
export { CustomField };
